import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { MdSearch } from "react-icons/md";
// import FinanceDash from "../../../../../components/features/finance/financel3/FinanceDash";
// import SalesFinance from "./SalesFinance";
// import SalesPiechart from "../PiechartSalesFinance/SalesPiechart";

// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import { useSnackbar } from "notistack";
// import SliderValueLabel from "@mui/material/Slider/SliderValueLabel";
// import TextSnippetIcon from '@mui/icons-material/TextSnippet';

import { fetchAllFinancial } from "../../../store/slices/editFinanceSlice";
import { fetchSalesTaxes } from "../../../store/slices/salesTaxesSlice";
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import { setOtheeExpensesData } from "../../../store/slices/filteredDataSlice";
import { fetchCompanyProfiles } from "../../../store/slices/companyProfileSlice";
import { fetchOtherExpenses } from "../../../store/slices/otherexpenses";
import {
  fetchLeads,
  fetchEmployeeAuthData,
  invalidateLeadsCache,
  // updateLead
} from "../../../store/slices/leadsSlice";
import { fetchGroups } from "../../../store/slices/groupSlice";
import { fetchEmployees } from "../../../store/slices/employeeAdminSlice";
import { fetchWorkEntries } from "../../../store/slices/workentriesSlice";
import { fetchHardwareDescriptions } from "../../../store/slices/hardwareDescriptionSlice";
import { fetchDescriptionTasks } from "../../../store/slices/DescriptionTask";
import { fetchQuotations } from "../../../store/slices/hourlyRates";
import ActualFinanceView from "./ActualFinanceView";
import CommaConvert from "../../../utils/CommaConvert";
import { hasViewOrFullAccess, getFeatureAccessLevel } from "../../../utils/featureAccessUtils";
// import FinanceData from "./FinanceData";
// import FinanceFileUpload from "./FinanceFileUpload";
// import ManagerTable from "./ManagerTable";

const FinanceOverview = () => {
  const dispatch = useDispatch();
    const USAComma = CommaConvert();
  // const { enqueueSnackbar } = useSnackbar();
  const [financeTab,] = useState("table");
  
  const [
    // showAllLeadTable
    , setShowAllLeadTable] = useState(true);
  const [
    // calculationTable
    , setCalculationTable] = useState(false);
  const [l3Leads, setL3Leads] = useState([]);
  const [loggedUserData, setLoggedUserData] = useState([]);
  const [GroupNamesL3, setGroupNamesL3] = useState([]);
  const [isGroupOpen, setIsGroupOpen] = useState(false);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [selectedProjectName,
    // setSelectedProjectName
  ] = useState({});
  const [AssignedGroup, setAssignedGroup] = useState("");
  const [clientFilter, setClientFilter] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [yearData, setYearData] = useState([]);
  const [isYearOpen, setIsYearOpen] = useState(false);
  const [expandedYear, setExpandedYear] = useState(null);
  const currentYear = new Date().getFullYear();
  const [selectedYears, setSelectedYears] = useState([currentYear.toString()]); // Store selected years
  const [searchedLeadReports, setSearchedLeadReports] = useState([]);
  const [searchedLeadReportswithoutyears, setSearchedLeadReportswithoutyears] = useState([]);
  const dropdownRefclient = useRef(null);
  // const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
  // const [filteredQuotation, setFilteredQuotation] = useState(null);
  // const [GandATax, setGandATax] = useState(0);
  // const [taxValue, setTaxValue] = useState(0);
  const { group } = useSelector((state) => state.group);
  const { leads, allLeads } = useSelector((state) => state.leads);
  const { taxes } = useSelector((state) => state.salesTaxes);
  const { projects } = useSelector((state) => state.projects);
  const { profiles } = useSelector((state) => state.companyProfile);
  const { entries } = useSelector((state) => state.workentries);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { quotations } = useSelector((state) => state.hourlyRateQuotation);
  const { employees } = useSelector((state) => state.employees);
  const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
  const { activeSection } = useSelector((state) => state.scroll);
  const { session } = useSelector((state) => state.session);
  const [
    // quotedValues
    , setQuotedValues] = useState({}); // Changed to object to store values by project
  const [perdiem, setperdiem] = useState(0);
  const [averagecost, setaveragecost] = useState(0);
  // const AllServiceTableRef = useRef(null);
  // const debounceTimeoutRef = useRef(null); // Add this ref for debounce

  // const [selectedTab, setSelectedTab] = useState(""); // default to first tab
  const [financeDataProject, setfinanceDataProject] = useState([]);
  const [, setComments] = useState({});
  // const [button, setbutton] = useState("QuotedExpense");
  const [showTable,
    //  setshowTable
  ] = useState("Actual");
 
  // const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [leadData, setLeadData] = useState([]);
  const [calculatedProjects, setCalculatedProjects] = useState([]);

  const pkgNormalized = String(profiles?.[0]?.subscriptionpackage || "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
  // Default to CRM when package not yet loaded so P&L table uses allLeads for finance (e.g. "Packages Switch CRM")
  const isCrmPackage =
    pkgNormalized === "crm" ||
    pkgNormalized.includes("crm") ||
    (pkgNormalized.length > 0 && !pkgNormalized.includes("erp")) ||
    (pkgNormalized.length === 0);

  // Finance person (PROFIT AND LOSS): always use allLeads for P&L table so they see all leads in CRM package even if subscriptionpackage is missing in company profile
  const loggedEmail = typeof localStorage !== "undefined" ? localStorage.getItem("email") : "";
  const currentEmployee = employees?.find(
    (e) => (e.EmpEmail || "").trim().toLowerCase() === (loggedEmail || "").trim().toLowerCase()
  );
  const isFinanceWithPL = hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS");

  // L2 with "No Access" to PROFIT AND LOSS: hide P&L table (and sidebar is already hidden).
  const plAccessLevel = getFeatureAccessLevel(currentEmployee, "PROFIT AND LOSS");
  const isL2NoAccessToPL =
    (currentEmployee?.EmpAuthLevel || session?.auth || localStorage.getItem("auth") || "") === "L2" &&
    String(plAccessLevel || "").trim().toUpperCase() === "NO ACCESS";
  const showPLTable = !isL2NoAccessToPL;

  const getRowKey = (row) =>
    row?.quotationId != null && String(row.quotationId).trim() !== ""
      ? String(row.quotationId).trim()
      : row?.ProjectName ?? "";

  const resolveId = useCallback((value) => {
    if (!value) return "";
    if (typeof value === "string" || typeof value === "number") {
      return String(value).trim();
    }
    return String(value?._id || value?.id || "").trim();
  }, []);

  const getGroupIdFromRow = useCallback((row) =>
    resolveId(row?.groupid) ||
    resolveId(row?.projectdata?.groupid) ||
    resolveId(row?.lead?.groupid) ||
    resolveId(row?.project?.groupid), [resolveId]);

  const getProjectGroupIdFromRow = useCallback((row) => {
    const rowQuotationId = resolveId(row?.quotationId);
    const rowProjectName = String(row?.ProjectName || "").trim().toLowerCase();

    const matchedProject = (projects || []).find((proj) => {
      const projQuotationId = resolveId(proj?.quotationId);
      if (rowQuotationId && projQuotationId) {
        return projQuotationId === rowQuotationId;
      }
      return String(proj?.ProjectName || "").trim().toLowerCase() === rowProjectName;
    });

    return resolveId(matchedProject?.groupid);
  }, [projects, resolveId]);

  const getGroupNameById = useCallback((groupId) => {
    const resolvedGroupId = resolveId(groupId);
    if (!resolvedGroupId) return "";
    const matchedGroup = (group || []).find(
      (grp) => resolveId(grp?._id || grp?.id) === resolvedGroupId
    );
    return matchedGroup?.newGroupName || matchedGroup?.name || "";
  }, [group, resolveId]);

  const getGroupDisplayName = useCallback((row) =>
    getGroupNameById(getGroupIdFromRow(row) || getProjectGroupIdFromRow(row)) ||
    row?.AssignedGroup ||
    row?.projectdata?.AssignedGroup ||
    "", [getGroupNameById, getGroupIdFromRow, getProjectGroupIdFromRow]);

  // CRM or finance person (PROFIT AND LOSS): P&L table always use allLeads so they see all leads. Otherwise use leads when non-empty, else allLeads.
  // When package is CRM, show only leads with status=won so L2 (all groups) sees all won leads.
  useEffect(() => {
    const useAllLeads = isCrmPackage || isFinanceWithPL;
    let source = useAllLeads
      ? (allLeads || [])
      : ((!leads || leads.length === 0) ? (allLeads || []) : (leads || []));
    if (isCrmPackage && source.length > 0) {
      source = source.filter((lead) => {
        const status = (lead.Status || lead.status || "")
          .toString()
          .trim()
          .toLowerCase();
        return status === "won" || status === "won recurring";
      });
    }
    setLeadData(source);
  }, [leads, allLeads, isCrmPackage, isFinanceWithPL]);

  useEffect(() => {
    const isProjecttracking = !isCrmPackage;
    const filteredProject = projects.filter(
      (proj) => proj.isProjecttracking === isProjecttracking
    );

    const qualifiedGroups = filteredProject.filter((project) => {
      if (!project?.Assignedperson?.length) return false;

      if (isCrmPackage) {
        return project.Assignedperson.some((person) =>
          (person.salespersonaction === "accept" ||
            person.salespersonaction === "project not-assigned") &&
          (person.salespersonstatus === "response received" ||
            person.salespersonstatus === "project approved" ||
            person.salespersonstatus === "project not-approved" ||
            person.salespersonstatus === "project assigned" ||
            person.salespersonstatus === "project not-assigned")
        );
      }
      return project.Assignedperson.some(
        (person) =>
          person.salespersonstatus === "project ongoing" ||
          person.salespersonstatus === "project complete"
      );
    });
    setfinanceDataProject(qualifiedGroups);
  }, [projects, isCrmPackage]);

  // const refsMap = {
  //   AllServiceTable: AllServiceTableRef,

  // };
  // const handleTabClick = (tabKey) => {
  //   setSelectedTab(tabKey);
  //   setTimeout(() => {
  //     refsMap[tabKey]?.current?.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }, 100); // slight delay so component mounts first
  // };

  useEffect(() => {
    dispatch(fetchAllFinancial());
    dispatch(fetchSalesTaxes());
    dispatch(fetchAllProjects());
    dispatch(setOtheeExpensesData())
    dispatch(fetchCompanyProfiles());
    dispatch(fetchOtherExpenses());
  }, [dispatch]);

  const [matchedProjects, setMatchedProjects] = useState([]); // always an array
  const [matchedEntries, setMatchedEntries] = useState([]); // ✅ will store matched entries


  useEffect(() => {
    if (selectedProjectName?.quotationId && financeDataProject?.length) {
      const matches = financeDataProject.filter((proj) => {
        // Filter by quotationId (projectName kept for display only)
        return proj.quotationId === selectedProjectName.quotationId;
      });



      setMatchedProjects(matches); // will only contain projects with valid assigned persons
    } else {
      setMatchedProjects([]); // reset if no match
    }
  }, [selectedProjectName, financeDataProject]);

  useEffect(() => {
    if (matchedProjects.length && entries.length) {
      const matchedIds = matchedProjects.map((proj) => proj._id);
      const filteredEntries = entries.filter((entry) =>
        matchedIds.includes(entry.projectid)
      );

      const matchedPersons = matchedProjects.flatMap((project) =>
        (project.Assignedperson || [])
          .map((person) => ({
            ...person,
            projectid: project._id,
            ProjectName: project.ProjectName, // optional
          }))
      );
     

      const matchedEmployees = employees.filter((employee) =>
        matchedPersons.some(
          (person) =>
            person.email?.trim().toLowerCase() ===
            employee.EmpEmail?.trim().toLowerCase()
        )
      );

      const matchedPeopleEntries = filteredEntries.filter((entry) =>
        matchedEmployees.some(
          (employee) => employee._id?.trim() === entry.taskownerid?.trim()
        )
      );

      setMatchedEntries(matchedPeopleEntries);
    } else {
      setMatchedEntries([]);
    }
  }, [matchedProjects, entries, employees]);

  const [matchedHardwareEntries, setMatchedHardwareEntries] = useState([]); // ✅ will store matched entries

  useEffect(() => {
    if (matchedProjects.length && items.length) {
      const matchedIds = matchedProjects.map((proj) => proj._id);
      const filteredEntries = items.filter((entry) =>
        matchedIds.includes(entry.projectid)
      );

      const matchedPersons = matchedProjects.flatMap((project) =>
        (project.Assignedperson || [])
          .map((person) => ({
            ...person,
            projectid: project._id,
            ProjectName: project.ProjectName, // optional
          }))
      );


      const matchedEmployees = employees.filter((employee) =>
        matchedPersons.some(
          (person) =>
            person.email?.trim().toLowerCase() ===
            employee.EmpEmail?.trim().toLowerCase()
        )
      );

      const matchedPeopleEntries = filteredEntries.filter((entry) =>
        matchedEmployees.some(
          (employee) => employee._id?.trim() === entry.taskownerid?.trim()
        )
      );

      setMatchedHardwareEntries(matchedPeopleEntries);
    } else {
      setMatchedHardwareEntries([]);
    }
  }, [matchedProjects, items, employees]);

  useEffect(() => {
    if (matchedHardwareEntries.length) {
      setMatchedEntries(prevEntries => [...prevEntries, ...matchedHardwareEntries]);
    }

  }, [matchedHardwareEntries]);

  const [groupedProj, setGroupedProj] = useState({});
  const [finalMappedEntries, setFinalMappedEntries] = useState([]);

  useEffect(() => {
    if (matchedEntries.length && employees.length) {
      const mapped = matchedEntries.map((entry) => {
        const matchedEmp = employees.find((emp) => emp._id === entry.taskownerid);

        // Check if this is a hardware entry (has hardware-specific properties)
        const isHardwareEntry = entry.hasOwnProperty('assemblepartdescription') ||
          entry.hasOwnProperty('partno') ||
          entry.hasOwnProperty('quantity');

        if (isHardwareEntry) {
          // Map hardware entries
          return {
            createdBy: {
              email: matchedEmp?.EmpEmail || "",
              name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""}`,
              role: matchedEmp?.customRoles || [],
            },
            assemblepartdescription: entry.assemblepartdescription,
            partno: entry.partno,
            quantity: entry.quantity,
            unitprice: entry.unitprice,
            totalprice: entry.totalprice,
            permonth: entry.permonth,
            taskstatus: entry.taskstatus,
            _id: entry._id,
            taskownerid: entry.taskownerid,
            TypeService: entry.typeservice || "Hardware", // Use the existing typeservice field
            projectid: entry.projectid,
          }
        } else {
          // Map software/cloud/installation entries (your existing logic)
          return {
            createdBy: {
              email: matchedEmp?.EmpEmail || "",
              name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""}`,
              role: matchedEmp?.customRoles || [],
            },
            task: entry.task,
            hoursassigned: entry.hoursassigned,
            taskStatus: entry.taskStatus,
            notes: entry.notes,
            _id: entry._id,
            taskownerid: entry.taskownerid,
            TypeService: entry.typeservice || matchedEmp?.servicetype,
            projectid: entry.projectid,
          };
        }
      });

      setFinalMappedEntries(mapped);
    } else {
      setFinalMappedEntries([]);
    }
  }, [matchedEntries, employees]);

  useEffect(() => {
    if (!projects || projects.length === 0 || !employees) return;
    

    const grouped = {};
    projects.forEach((proj) => {
      const projectName = proj.ProjectName;
      const typeService = proj.TypeService;
      const projectId = proj._id;

      // Filter finalMappedEntries that match both TypeService and project ID
      const matchedEntries = finalMappedEntries.filter(
        (entry) =>
          entry.TypeService === typeService && entry.projectid === projectId
      );

      // If no matched entries, skip this project
      if (matchedEntries.length === 0) return;
      const salesperson = employees.find(
        (emp) => emp.EmpEmail === proj.SalesPersonEmail
      );

      const filteredProject = {
        TypeService: proj.TypeService,
        ResourceType: proj.ResourceType,
        ProjectName: proj.ProjectName,
        QuotedValue: proj.ServiceValue,
        WorkEntries: matchedEntries,
        AssignedGroup: proj.AssignedGroup,
        AssignedManagerEmail: proj.AssignedManagerEmail,
        Assignedperson: proj.Assignedperson,
        ProjectID: proj._id,
        ProjectNotes: proj?.ProjectFinanceNotes,
        SalesPersonId: salesperson ? salesperson._id : null // Add salesperson _id or null if not found

      };


      if (!grouped[projectName]) {
        grouped[projectName] = {};
      }

      if (!grouped[projectName][typeService]) {
        grouped[projectName][typeService] = [];
      }

      grouped[projectName][typeService].push(filteredProject);
    });

    setGroupedProj(grouped);
  }, [projects, employees, finalMappedEntries]);

  const [, setMatchedQuotations] = useState({});
  
  useEffect(() => {
    if (!quotations || !groupedProj) return;
    const updatedGroupedProj = {};
    // Lop through each project
    Object.entries(groupedProj).forEach(([projectName, serviceTypes]) => {
      updatedGroupedProj[projectName] = {};

      // Loop through each TypeService within that project
      Object.entries(serviceTypes).forEach(([typeService, serviceArray]) => {
        // Keep the original service array
        const updatedServiceArray = serviceArray.map((entry) => {
          // Match quotations where designation includes TypeService
          const matchedQuotations = quotations.filter((q) =>
            q.designation?.toLowerCase().includes(typeService.toLowerCase()) &&
            q.createdBy === entry.SalesPersonId
          );


       
          return {
            ...entry,
            quotationDetails: matchedQuotations, // add new key with matched quotations
          };
        });

        updatedGroupedProj[projectName][typeService] = updatedServiceArray;
      });
    });

    setMatchedQuotations(updatedGroupedProj);
  }, [quotations, groupedProj]);

  // useEffect(() => {
  //   if (!selectedProjectName?.ProjectName || !matchedQuotations) return;

  //   const match = matchedQuotations[selectedProjectName.ProjectName];

  //   if (match) {
  //     setFilteredQuotation({ [selectedProjectName.ProjectName]: match });
  //   } else {
  //     setFilteredQuotation(null); // or {} if you prefer
  //   }
  // }, [selectedProjectName, matchedQuotations]);

  // useEffect(() => {
  //   if (profiles[0]?.subscriptionpackage) {
  //     setSelectedServiceTypes(profiles[0]?.subscriptionpackage);
  //   }
  // }, [profiles]);
  // CRM or finance person (PROFIT AND LOSS): P&L table always use allLeads so they see all leads. Otherwise use leads when non-empty, else allLeads.
  // When package is CRM, show only leads with status=won so L2 (all groups) sees all won leads.
  useEffect(() => {
    const useAllLeads = isCrmPackage || isFinanceWithPL;
    let source = useAllLeads
      ? (allLeads || [])
      : ((!leads || leads.length === 0) ? (allLeads || []) : (leads || []));
    if (isCrmPackage && source.length > 0) {
      source = source.filter((lead) => {
        const status = (lead.Status || lead.status || "")
          .toString()
          .trim()
          .toLowerCase();
        return status === "won" || status === "won recurring";
      });
    }
    setL3Leads(source);
    if (group && Array.isArray(group)) {
      const groupIds = new Set(
        source.map((l) => getGroupIdFromRow(l)).filter(Boolean)
      );
      setGroupNamesL3(
        group.filter((g) => groupIds.has(resolveId(g?._id || g?.id)))
      );
    } else {
      setGroupNamesL3(group || []);
    }
  }, [leads, allLeads, group, isCrmPackage, isFinanceWithPL, getGroupIdFromRow, resolveId]);

  useEffect(() => {
    if (l3Leads) {
      setLoggedUserData([...l3Leads].reverse());
    }
  }, [l3Leads, taxes]);

  const dropdownRefGroup = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefGroup.current &&
        !dropdownRefGroup.current.contains(event.target)
      ) {
        setIsGroupOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const dropdownRefYear = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefYear.current &&
        !dropdownRefYear.current.contains(event.target)
      ) {
        setIsYearOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefclient.current &&
        !dropdownRefclient.current.contains(event.target)
      ) {
        setShowClientDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (loggedUserData.length === 0) return;

    let filtered = loggedUserData;
    // Filter by AssignedGroup (skip if "All")
    if (AssignedGroup && AssignedGroup !== "All") {
      filtered = filtered.filter(
        (lead) => getGroupIdFromRow(lead) === String(AssignedGroup)
      );
    }

    // Filter by ClientName (skip if "All")
    if (clientFilter && clientFilter !== "All") {
      filtered = filtered.filter((lead) => lead.ClientName === clientFilter);
    }

    setSearchedLeadReports(filtered);
    setSearchedLeadReportswithoutyears(filtered)
  }, [loggedUserData, AssignedGroup, clientFilter, getGroupIdFromRow]);


  // Inside your component
  const uniqueClients = [
    ...new Map(
      leadData.map((lead) => [
        lead.ClientName?.trim().toLowerCase(), // key for uniqueness
        lead.ClientName?.trim(), // value for display
      ])
    ).values(),
  ].sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" })); // sort alphabetically, ignore case

  const itemsPerPage = 10;
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  // Used by commented P&L table block (lines ~1691–2081); ActualFinanceView uses searchedLeadReports directly
  /* eslint-disable-next-line no-unused-vars */
  const currentItems = searchedLeadReports.slice(startIdx, endIdx);

  const totalItems = searchedLeadReports.length;
  /* eslint-disable-next-line no-unused-vars */
  const totalPages = Math.ceil(totalItems / itemsPerPage);


  // const sortAlphabetically = (targetToSort, order) => {
  //   const key = `${targetToSort}-${order}`;
  //   const sortedReports = [...searchedLeadReports];

  //   switch (key) {
  //     case "projectname-az":
  //       sortedReports.sort((a, b) =>
  //         a.ProjectName?.trim()
  //           .toLowerCase()
  //           .localeCompare(b.ProjectName?.trim().toLowerCase())
  //       );
  //       break;

  //     case "projectname-za":
  //       sortedReports.sort((a, b) =>
  //         b.ProjectName?.trim()
  //           .toLowerCase()
  //           .localeCompare(a.ProjectName?.trim().toLowerCase())
  //       );
  //       break;

  //     default:
  //       console.error("Invalid Order");
  //   }

  //   setLoggedUserData(sortedReports);
  // };

  // const numericSort = (order) => {
  //   const sortedReports = [...searchedLeadReports];

  //   order === "az"
  //     ? sortedReports.sort(
  //       (a, b) => Number(a.QuotedValue) - Number(b.QuotedValue)
  //     )
  //     : sortedReports.sort(
  //       (a, b) => Number(b.QuotedValue) - Number(a.QuotedValue)
  //     );

  //   setLoggedUserData(sortedReports); // Update the state
  // };

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value; // Remove leading/trailing spaces
    setSearchQuery(query);
    setCurrentPage(1); // ✅ Reset to first page when searching
  };
  // Ensure auth (L2) is set before fetching leads so slice does not filter with stale L3 groups; then fetch so finance sees P&L data.
  // Invalidate leads cache when P&L page loads so finance (L2) always gets a fresh GET /leads and sees all leads in CRM package.
  useEffect(() => {
    dispatch(invalidateLeadsCache());
    dispatch(fetchEmployeeAuthData()).then(() => {
      dispatch(fetchLeads());
    });
    dispatch(fetchGroups());
  }, [dispatch]);

  // When user clicks "Profit and Loss Tracker" in sidebar: refresh data so L2 always sees fresh P&L table
  useEffect(() => {
    if (activeSection === "Profit and Loss Tracker") {
      dispatch(invalidateLeadsCache());
      dispatch(fetchEmployeeAuthData()).then(() => {
        dispatch(fetchLeads());
      });
      dispatch(fetchGroups());
    }
  }, [activeSection, dispatch]);

  const handleClientChange = (clientValue) => {
    setClientFilter(clientValue);
    setShowClientDropdown(false);
  };
  //for one years//
  // useEffect(() => {
  //   let filteredData = [...loggedUserData];
  //   // Define quarter ranges
  //   const quarterMapping = {
  //     "Jan - Mar": ["Jan", "Feb", "Mar"],
  //     "Apr - Jun": ["Apr", "May", "Jun"],
  //     "Jul - Sep": ["Jul", "Aug", "Sep"],
  //     "Oct - Dec": ["Oct", "Nov", "Dec"],
  //     "Apr - Jul": ["Apr", "May", "Jun", "Jul"], // if custom
  //     "Aug - Nov": ["Aug", "Sep", "Oct", "Nov"],
  //     "Dec - Mar": ["Dec", "Jan", "Feb", "Mar"],
  //   };

  //   // Filter by selected years
  //   if (selectedYears.length > 0) {
  //     filteredData = filteredData.filter((lead) => {
  //       const leadDate = new Date(lead.LeadDate);
  //       const leadYear = leadDate.getFullYear().toString();
  //       const leadMonth = leadDate.toLocaleString("default", {
  //         month: "short",
  //       });

  //       return selectedYears.some((entry) => {
  //         const entryStr = String(entry).trim();
  //         const [entryYear, ...rest] = entryStr.split(" ");
  //         const joinedRest = rest
  //           .join(" ")
  //           .replace(/\s*-\s*/g, " - ")
  //           .trim();

  //         const normalizedMonth = leadMonth.trim(); // e.g. "Aug"
  //         const normalizedJoined = joinedRest; // "Feb" or "Apr - Jun"

  //         // ✅ Match year only (e.g. "2025")
  //         if (entryStr === leadYear) return true;

  //         // ✅ Match month (e.g. "2025 Feb")
  //         if (
  //           entryYear === leadYear &&
  //           normalizedJoined.toLowerCase() === normalizedMonth.toLowerCase()
  //         )
  //           return true;

  //         // ✅ Match quarter (e.g. "2025 Apr - Jun")
  //         if (
  //           entryYear === leadYear &&
  //           quarterMapping[normalizedJoined]?.includes(normalizedMonth)
  //         )
  //           return true;

  //         return false;
  //       });
  //     });
  //     setSearchedLeadReports(filteredData);
  //   }
  // }, [loggedUserData, selectedYears]);

  // Note: showExpensesop is defined later but moved here to avoid "used before defined" error
  // It depends on calculatedProjects which is a state variable available in closure
  const showExpensesop = useCallback((projectName, quotationId) => {
    const projectsGroupedByName = financeDataProject.reduce((acc, project) => {
      const existingGroup = acc.find(
        (g) => (project.quotationId && g.quotationId === project.quotationId) || (!project.quotationId && g.ProjectName === project.ProjectName)
      );
      if (existingGroup) {
        existingGroup.Projects.push(project);
      } else {
        acc.push({
          ProjectName: project.ProjectName,
          quotationId: project.quotationId,
          Projects: [project],
        });
      }
      return acc;
    }, []);

    const isQualifiedProject = quotationId
      ? projectsGroupedByName.some((group) => group.quotationId === quotationId)
      : projectsGroupedByName.some((group) => group.ProjectName === projectName);

    if (!isQualifiedProject) {
      return "0";
    }

    const project = quotationId
      ? calculatedProjects.find((p) => p.quotationId === quotationId)
      : calculatedProjects.find((p) => p.ProjectName === projectName);
    if (!project) {
      return "0";
    }

    const grandTotal = project.DescriptionValue + project.HardwareListValue + project.TaskListValue;

    return `${USAComma(grandTotal)}`;
  }, [financeDataProject, calculatedProjects, USAComma]);

  useEffect(() => {
    let filteredData = [...loggedUserData];

    // Apply group filter
    if (AssignedGroup && AssignedGroup !== "All") {
      filteredData = filteredData.filter(
        (lead) => getGroupIdFromRow(lead) === String(AssignedGroup)
      );
    }

    // Apply client filter
    if (clientFilter && clientFilter !== "All") {
      filteredData = filteredData.filter((lead) => lead.ClientName === clientFilter);
    }

    // Define quarter ranges
    const quarterMapping = {
      "Jan - Mar": ["Jan", "Feb", "Mar"],
      "Apr - Jun": ["Apr", "May", "Jun"],
      "Jul - Sep": ["Jul", "Aug", "Sep"],
      "Oct - Dec": ["Oct", "Nov", "Dec"],
      "Apr - Jul": ["Apr", "May", "Jun", "Jul"],
      "Aug - Nov": ["Aug", "Sep", "Oct", "Nov"],
      "Dec - Mar": ["Dec", "Jan", "Feb", "Mar"],
    };

    // Filter by selected years (only if years are selected)
    // Support both LeadDate and leadDate (API may return either)
    if (selectedYears.length > 0) {
      filteredData = filteredData.filter((lead) => {
        const dateRaw = lead.LeadDate ?? lead.leadDate;
        const leadDate = new Date(dateRaw);
        if (!dateRaw || isNaN(leadDate.getTime())) return false; // Exclude leads with missing/invalid dates when year filter is applied
        const leadYear = leadDate.getFullYear().toString();
        const leadMonth = leadDate.toLocaleString("default", {
          month: "short",
        });

        return selectedYears.some((entry) => {
          const entryStr = String(entry).trim();
          const [entryYear, ...rest] = entryStr.split(" ");
          const joinedRest = rest
            .join(" ")
            .replace(/\s*-\s*/g, " - ")
            .trim();

          const normalizedMonth = leadMonth.trim();
          const normalizedJoined = joinedRest;

          // ✅ Match year only (e.g. "2025")
          if (entryStr === leadYear) return true;

          // ✅ Match month (e.g. "2025 Feb")
          if (
            entryYear === leadYear &&
            normalizedJoined.toLowerCase() === normalizedMonth.toLowerCase()
          )
            return true;

          // ✅ Match quarter (e.g. "2025 Apr - Jun")
          if (
            entryYear === leadYear &&
            quarterMapping[normalizedJoined]?.includes(normalizedMonth)
          )
            return true;

          return false;
        });
      });
    }

    // Apply search query filter (after year/group/client filters to ensure year filter is always respected)
    const searchTrimmed = searchQuery?.trim().replace(/,/g, "") || "";
    if (searchTrimmed) {
      const lowerCaseQuery = searchTrimmed.toLowerCase();
      filteredData = filteredData.filter((leadReport) => {
        const projectName = leadReport.ProjectName?.toLowerCase() || "";
        const quotedValue = String(leadReport.QuotedValue || "").toLowerCase();
        const ClientName = String(leadReport.ClientName || "").toLowerCase();
        const assignedGroupName = String(getGroupDisplayName(leadReport) || "").toLowerCase();

        // Search by explicit quoted expenses
        const quotedExpenses = String(leadReport.quotedExpense || "").toLowerCase();

        // Search by calculated expenses (fallback when no quoted expense is set)
        const calculatedExpenses = showExpensesop(leadReport.ProjectName, leadReport.quotationId).toLowerCase().replace(/[$,]/g, "");

        return (
          projectName.includes(lowerCaseQuery) ||
          quotedValue.includes(lowerCaseQuery) ||
          quotedExpenses.includes(lowerCaseQuery) ||
          calculatedExpenses.includes(lowerCaseQuery) ||
          ClientName.includes(lowerCaseQuery) ||
          assignedGroupName.includes(lowerCaseQuery)
        );
      });
    }

    // Always set the filtered data (whether years are selected or not)
    setSearchedLeadReports(filteredData);
  }, [loggedUserData, selectedYears, AssignedGroup, clientFilter, searchQuery, showExpensesop, getGroupDisplayName, getGroupIdFromRow]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const allMonths = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const quarters = ["Jan - Mar", "Apr - Jun", "Jul - Sep", "Oct - Dec"];

    const data = Array.from({ length: 5 }, (_, i) => {
      const year = currentYear - i;
      return {
        Year: year,
        months: allMonths,
        quarter: quarters,
      };
    });

    setYearData(data);
  }, []);

  const handleYearSelection = (value) => {
    setSelectedYears((prev) => {
      if (prev.includes(value)) {
        // Remove value if already selected
        return prev.filter((item) => item !== value);
      } else {
        // Add value if not already selected
        return [value];
      }
    });
  };

  useEffect(() => {
    dispatch(fetchEmployees());
    dispatch(fetchWorkEntries());
    dispatch(fetchAllProjects());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchQuotations());
    dispatch(fetchOtherExpenses());
    dispatch(fetchSalesTaxes());
  }, [dispatch]);


  // useEffect(() => {

  //   const userEmail = localStorage.getItem("email");
  //   const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
  //   const filteredTaxes = taxes.filter(tax => tax.createdBy === currentEmployee?._id);
  //   filteredTaxes?.forEach((data) => {
  //     if (data.taxName === "G&A Expenses") {
  //       setGandATax(data.taxPercentage);
  //     } else if (data.taxName === "Tax") {
  //       setTaxValue(data.taxPercentage);
  //     }
  //   });
  // }, [taxes, employees]);

  const [searchedCalcProjects, setSearchedCalcProjects] = useState([]);
  useEffect(() => {
    if (!searchedLeadReports || !financeDataProject) return; // guard

    // Find projects that have a match in searchedLeadReports (filter by quotationId, fallback to ProjectName)
    const matchedProjects = financeDataProject.filter((row) =>
      searchedLeadReports.some((proj) => getRowKey(proj) === getRowKey(row))
    );

    setSearchedCalcProjects(matchedProjects);
  }, [searchedLeadReports, financeDataProject]);

  const [mergedProjects, setMergedProjects] = useState([]);

  useEffect(() => {
    if (!searchedCalcProjects || !tasks || !entries) return;

    const newData = searchedCalcProjects.map((proj) => {
      const matchedEntries = entries.filter(
        (entry) => entry.projectid === proj._id
      );

      const matchedDescriptions = tasks.filter(
        (task) => task.projectid === proj._id
      );
      const matchedHardware = items.filter(
        (task) => task.projectid === proj._id
      );

      return {
        ProjectName: proj.ProjectName,
        quotationId: proj.quotationId,
        TaskList: matchedEntries,
        Description: matchedDescriptions,
        TypeService: proj.TypeService,
        HardwareList: matchedHardware,
        Assignedperson: proj.Assignedperson,
        SalesPersonEmail: proj.SalesPersonEmail,
        AssignedManagerEmail: proj.AssignedManagerEmail[0],

      };
    });

    setMergedProjects(newData);
  }, [searchedCalcProjects, tasks, entries, items]);

  const [combinedProjects, setCombinedProjects] = useState([]);

  useEffect(() => {
    if (!mergedProjects || mergedProjects.length === 0) return;

    const grouped = Object.values(
      mergedProjects.reduce((acc, project) => {
        const key = project.quotationId || project.ProjectName;
        if (!acc[key]) {
          acc[key] = {
            ProjectName: project.ProjectName,
            quotationId: project.quotationId,
            salespersonEmail: project.SalesPersonEmail,
            TaskList: [],
            Description: [],
            HardwareList: [],
          };
        }

        acc[key].TaskList.push(...(project.TaskList || []));
        acc[key].Description.push(
          ...(project.Description || [])
        );
        acc[key].HardwareList.push(
          ...(project.HardwareList || [])
        );

        return acc;
      }, {})
    );

    setCombinedProjects(grouped);
  }, [mergedProjects]);

  const [groupedProjects, setGroupedProjects] = useState([]);


  useEffect(() => {
    if (!combinedProjects || !employees) return;


    const updatedProjects = combinedProjects.map((project) => {
      // helper to map arrays
      const enrichWithDesignation = (arr) =>
        arr.map((item) => {
          const emp = employees.find(
            (e) => e._id === item.taskownerid || e._id === item.createdBy
          );
          if (emp) {
            return {
              ...item,
              designation: `${emp.servicetype || ""} ${emp.customRoles?.[0] || ""
                }`.trim(),
            };
          }
          return item;
        });

      return {
        ...project,
        Description: project.Description
          ? enrichWithDesignation(project.Description)
          : [],
        TaskList: project.TaskList
          ? enrichWithDesignation(project.TaskList)
          : [],
        HardwareList: project.HardwareList
          ? enrichWithDesignation(project.HardwareList)
          : [],
      };
    });

    setGroupedProjects(updatedProjects);
  }, [combinedProjects, employees]);

  const [quotationProjects, setquotationProjects] = useState([]);

  useEffect(() => {
    if (quotationProjects?.length) {
      dispatch(setOtheeExpensesData(quotationProjects))
    }
  }, [dispatch, quotationProjects]);

  // useEffect(() => {
  //   if (!groupedProjects || !quotations) return;

  //   const updatedProjects = groupedProjects.map((project) => {
  //     // helper to map arrays and add hourlysalaray
  //     const enrichWithQuotation = (arr) =>
  //       arr.map((item) => {
  //         if (!item.designation) return item;

  //         const matchedQuote = quotations.find(
  //           (q) => q.designation === item.designation
  //         );
  //         


  //         if (matchedQuote) {
  //           return {
  //             ...item,
  //             hourlysalaray: matchedQuote.hourlysalaray || 0,
  //             overheadpercentage: matchedQuote.overheadpercentage || 0
  //           };
  //         }
  //         return item;
  //       });

  //     return {
  //       ...project,
  //       TaskList: project.TaskList ? enrichWithQuotation(project.TaskList) : [],
  //       Description: project.Description
  //         ? enrichWithQuotation(project.Description)
  //         : [],
  //       HardwareList: project.HardwareList
  //         ? enrichWithQuotation(project.HardwareList)
  //         : [],
  //     };
  //   });

  //   setquotationProjects(updatedProjects);
  // }, [groupedProjects, quotations]);


  useEffect(() => {
    if (!groupedProjects || !quotations || !employees) return;

    const updatedProjects = groupedProjects.map((project) => {
      // Find the employee based on AssignedManagerEmail
      const assignedEmployee = employees.find(
        (emp) => emp.EmpEmail === project.salespersonEmail
      );

      // If no employee found, return project as is
      if (!assignedEmployee) return project;

      // helper to map arrays and add hourlysalary with filtered quotations
      const enrichWithQuotation = (arr) =>
        arr.map((item) => {
          if (!item.designation) return item;

          // Find quotation that matches both designation AND createdBy matches employee _id
          const matchedQuote = quotations.find(
            (q) => q.designation === item.designation &&
              q.createdBy === assignedEmployee._id
          );

       

          if (matchedQuote) {
            return {
              ...item,
              hourlysalaray: matchedQuote.hourlysalaray || 0,
              overheadpercentage: matchedQuote.overheadpercentage || 0
            };
          }
          return item;
        });

      return {
        ...project,
        TaskList: project.TaskList ? enrichWithQuotation(project.TaskList) : [],
        Description: project.Description
          ? enrichWithQuotation(project.Description)
          : [],
        HardwareList: project.HardwareList
          ? enrichWithQuotation(project.HardwareList)
          : [],
      };
    });

    setquotationProjects(updatedProjects);
  }, [groupedProjects, quotations, employees]);


  const [, setInstallationDescriptions] = useState([]);

  useEffect(() => {
    if (!quotationProjects || quotationProjects.length === 0) return;

    const filteredProjects = quotationProjects
      .map((proj) => {
        const matchedDescriptions = (proj.Description || []).filter(
          (desc) =>
            desc.typeservice &&
            desc.typeservice.toLowerCase().includes("installation") &&
            desc.designation &&
            desc.designation.toLowerCase().includes("operations")
        );

        if (matchedDescriptions.length > 0) {
          return {
            ProjectName: proj.ProjectName,
            Description: matchedDescriptions,
          };
        }
        return null;
      })
      .filter(Boolean); // remove nulls

    setInstallationDescriptions(filteredProjects);
  }, [quotationProjects]);

  useEffect(() => {
    if (otherExpenses && otherExpenses.length > 0) {
      const perdiemExpense = otherExpenses.find(expense =>
        expense.description && expense.description.toLowerCase() === 'perdiem'
      );

      const averageCostExpense = otherExpenses.find(expense =>
        expense.description && expense.description.toLowerCase() === 'average cost'
      );

      setperdiem(perdiemExpense ? perdiemExpense.cost || 0 : 0);
      setaveragecost(averageCostExpense ? averageCostExpense.cost || 0 : 0);
    } else {
      setperdiem(0);
      setaveragecost(0);
    }
  }, [otherExpenses]);
  useEffect(() => {
    if (!quotationProjects || quotationProjects.length === 0) return;

    const newData = quotationProjects.map((proj) => {
      let taskValue = 0;
      let descriptionValue = 0;
      let hardwareValue = 0;

      // ✅ TaskList calculation
      if (proj.TaskList?.length > 0) {
        const hoursByOwner = {};

        proj.TaskList.forEach((task) => {
          if (task.taskownerid && task.hoursassigned) {
            if (!hoursByOwner[task.taskownerid]) {
              hoursByOwner[task.taskownerid] = {
                totalHours: 0,
                hourlyRate: task.hourlysalaray + task.overheadpercentage || 0
              };
            }
            hoursByOwner[task.taskownerid].totalHours += task.hoursassigned;
          }
        });

        Object.values(hoursByOwner).forEach((ownerData) => {
          taskValue += ownerData.totalHours * ownerData.hourlyRate;
        });
      }

      // ✅ Description calculation with Installation service condition
      if (proj.Description?.length > 0) {
        // Create a map to track trip duration per taskownerid for Installation services
        const installationTripByOwner = {};

        proj.Description.forEach((desc) => {

          // For Installation services, track trip duration per owner
          if (desc.typeservice && desc.typeservice.toLowerCase().includes('installation') &&
            desc.taskownerid && desc.tripduration) {
            if (!installationTripByOwner[desc.taskownerid]) {
              installationTripByOwner[desc.taskownerid] = desc.tripduration;
            } else {
              // Use the maximum trip duration for each owner
              installationTripByOwner[desc.taskownerid] =
                Math.max(installationTripByOwner[desc.taskownerid], desc.tripduration);
            }
          }

          // Add the normal value calculation
          if (desc.value) {
            descriptionValue += desc.value;
          }
        });

        // Add Installation trip duration calculations (per diem + other expenses)
        Object.values(installationTripByOwner).forEach((tripDuration) => {
          // Assuming you have state variables called perdiem and otherExpense
          descriptionValue += (tripDuration * perdiem) + (tripDuration * averagecost);
        });
      }

      // ✅ HardwareList calculation
      if (proj.HardwareList?.length > 0) {
        proj.HardwareList.forEach((hw) => {
          if (hw.totalprice) {
            hardwareValue += hw.totalprice;
          }
        });
      }

      return {
        ProjectName: proj.ProjectName,
        quotationId: proj.quotationId,
        TaskListValue: taskValue,
        DescriptionValue: descriptionValue,
        HardwareListValue: hardwareValue,
      };
    });

    setCalculatedProjects(newData);
  }, [quotationProjects, perdiem, averagecost]);



  useEffect(() => {
    if (searchedLeadReports.length > 0) {
      const initialValues = {};
      const initialComments = {};

      searchedLeadReports.forEach((lead) => {
        const key = getRowKey(lead);
        initialValues[key] = lead.QuotedValue || 0;
        initialComments[key] = lead.projectnotes || "";
      });
      setQuotedValues(initialValues);
      setComments(initialComments);
    }
  }, [searchedLeadReports]);

  // useEffect(() => {
  //   return () => {
  //     if (debounceTimeoutRef.current) {
  //       clearTimeout(debounceTimeoutRef.current);
  //     }
  //   };
  // }, []);

  // const calculateGrossProfit = (projectName) => {
  //   const quotedValue = quotedValues[projectName] || 0;
  //   const projectsGroupedByName = projects.reduce((acc, project) => {
  //     const existingGroup = acc.find(
  //       (g) => g.ProjectName === project.ProjectName
  //     );
  //     if (existingGroup) {
  //       existingGroup.Projects.push(project);
  //     } else {
  //       acc.push({
  //         ProjectName: project.ProjectName,
  //         Projects: [project],
  //       });
  //     }
  //     return acc;
  //   }, []);

  //   const qualifiedGroups = projectsGroupedByName.filter((group) => {
  //     return group.Projects.every((project) => {
  //       // Must have at least one assigned person
  //       if (!project?.Assignedperson?.length) return false;

  //       // All assigned persons must meet criteria
  //       return project.Assignedperson.every(
  //         (person) => person.salespersonaction === "accept"
  //       );
  //     });
  //   });


  //   const isQualifiedProject = financeDataProject.some(
  //     group => group.ProjectName === projectName
  //   );

  //   // If project is not qualified, return $0
  //   if (!isQualifiedProject) {
  //     return quotedValue;
  //   }
  //   const project = calculatedProjects.find(project => project.ProjectName === projectName);

  //   if (!project) {
  //     return quotedValue; // If no project found, gross profit equals quoted value
  //   }

  //   const calculatedExpense = project.DescriptionValue + project.HardwareListValue + project.TaskListValue;
  //   const grossProfit = quotedValue - calculatedExpense;
  //   return grossProfit;
  // };




  // const handleCommentsChange = (row, value) => {
  //   // Update local state immediately
  //   setComments(prev => ({
  //     ...prev,
  //     [row.ProjectName]: value
  //   }));

  //   // Clear previous timeout if it exists
  //   if (debounceTimeoutRef.current) {
  //     clearTimeout(debounceTimeoutRef.current);
  //   }

  //   // Set new timeout to call API after 1 second (debounce)
  //   debounceTimeoutRef.current = setTimeout(() => {
  //     updateComments(row, value);
  //   }, 1000);
  // };

  // const updateComments = async (selectedProject, newComment) => {
  //   try {
  //     const updatedLeadData = {
  //       projectnotes: newComment,
  //       ProjectName: selectedProject.ProjectName,
  //     };

  //     await dispatch(
  //       updateLead({ id: selectedProject.id, updatedData: updatedLeadData })
  //     ).unwrap();

  //     dispatch(fetchLeads());
  //     enqueueSnackbar("Notes Updated Successfully", {
  //       variant: "success",
  //     });

  //   } catch (error) {
  //     console.error("Error updating Notes:", error);
  //     enqueueSnackbar("Error updating Notes", {
  //       variant: "error",
  //     });
  //   }
  // };


  // const handlebuttons = async (tables) => {
  //   setshowTable(tables)

  // };

  // useEffect(() => {
  //   if (profiles[0]?.subscriptionpackage === "CRM") {
  //     setSelectedServiceTypes("CRM")
  //   } else if (profiles[0]?.subscriptionpackage === "ERP") {
  //     setSelectedServiceTypes("QuotedExpense")

  //   }
  // }, [profiles]);
  // const QuotationRef = useRef(null);
  const ActualRef = useRef(null);

  // const refsMaps = {
  //   Quotation: QuotationRef,
  //   Actual: ActualRef,
  // };

  // const handleTabClickbuttons = (tabKey) => {
  //   setSelectedTab(tabKey);
  //   setTimeout(() => {
  //     refsMaps[tabKey]?.current?.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }, 100);
  // };



  return (
    <>
      {showPLTable && (
      <div className="my-3 rounded-md">
        {/* for sales */}
        <div className="relative bg-white scroll-visible justify-center top-0">
          <div className="w-full relative pt-4  px-2 flex  align-middle items-center rounded-md">
            <div>
              <h1 className="text-xl font-semibold">Profit and Loss (P&L) Table</h1>
            </div>

            {/* <div className="flex gap-2 text-sm font-medium px-3">
              <button
                onClick={() => {
                  handlebuttons("QuotedExpense")
                  setbutton("QuotedExpense")
                  setCalculationTable(false);
                  handleTabClickbuttons("Quotation")

                }}
                className={`py-1 px-3 ${button === "QuotedExpense" ? "bg-[#156082] text-white border-[#156082]" : "bg-gray-200 border-gray-300 hover:bg-gray-300"}  border  shadow-md rounded-lg transition-all duration-200`}
              >
                Quoted
              </button>
              <button
                onClick={() => {
                  if (profiles[0]?.subscriptionpackage === "CRM") {
                    enqueueSnackbar("Please Upgrade The Package", {
                      variant: "error",
                    });
                  } else {
                    handlebuttons("Actual")
                    setbutton("Actual")
                    handleTabClickbuttons("Actual")

                  }

                }}
                className={`py-1 px-3 ${profiles[0]?.subscriptionpackage === "CRM" ? "opacity-50" : button === "Actual" ? "bg-[#156082] text-white border-[#156082]" : "bg-gray-200 border-gray-300 hover:bg-gray-300"} text-gray-800 border  shadow-md rounded-lg  transition-all duration-200`}
              >
                Actual
              </button>
            </div> */}
          </div>

          <div className="flex justify-between gap-2 bg-white rounded-md p-1">
            <div className="flex">
              <div className="flex gap-3 p-1">
                <div
                  className="relative flex gap-2 justify-center align-middle items-center"
                  ref={dropdownRefGroup}
                >
                  <label
                    htmlFor="selectedStatus"
                    className="block text-sm font-semibold text-gray-700 "
                  >
                    GROUP
                  </label>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsGroupOpen(!isGroupOpen);
                    }}
                    className="w-24 relative outline-none date-picker-placeholder flex justify-start border border-[#e0e7ff] rounded-md p-2 text-xs"
                  >
                    <span className="truncate min-w-0 flex-1 text-left">
                      {AssignedGroup ? getGroupNameById(AssignedGroup) : "All"}
                    </span>
                    <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                  </button>
                  {isGroupOpen && (
                    <div className="absolute left-0 top-full w-full text-xs border overflow-hidden text-wrap border-gray-400 bg-white shadow-md rounded-md z-50">
                      <div
                        className="p-2 hover:bg-gray-200 cursor-pointer"
                        onClick={() => {
                          setAssignedGroup("All");
                          setIsGroupOpen(false);
                          setShowAllLeadTable(true);
                          setCalculationTable(false);
                        }}
                      >
                        All
                      </div>
                      {GroupNamesL3.map((group) => (
                        <div
                          key={group._id || group.id}
                          className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${String(AssignedGroup) === String(group._id || group.id)
                            ? "bg-gray-300"
                            : ""
                            }`}
                          onClick={() => {
                            setAssignedGroup(group._id || group.id);
                            setIsGroupOpen(false);
                            setShowAllLeadTable(true);
                            setCalculationTable(false);
                            setClientFilter("");
                          }}
                        >
                          <label>{group.newGroupName || group.name}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex gap-2 align-middle items-center scale-90 z-50">
                <h1 className="font-semibold">CLIENT</h1>
                <div className="relative">
                  <div className="flex  p-0 border rounded-md align-middle items-center">
                    <ExpandMoreIcon
                      className="absolute right-1 cursor-pointer bg-white"
                      onClick={() => setShowClientDropdown(!showClientDropdown)}
                    />

                    <button
                      type="button"
                      onClick={() => setShowClientDropdown(!showClientDropdown)}
                      className=" text-left text-sm outline-none p-2 text-nowrap truncate w-40"
                    >
                      {clientFilter ? clientFilter : <p>Select Client</p>}
                    </button>
                  </div>

                  {showClientDropdown && (
                    <div
                      ref={dropdownRefclient}
                      className="absolute top-full left-0 w-full max-h-64 cursor-pointer overflow-y-auto bg-gray-100 text-sm border border-gray-300 shadow-lg z-50"
                    >
                      <p
                        className="p-2 hover:bg-gray-200 "
                        onClick={() => {
                          handleClientChange("All");
                          setShowAllLeadTable(true);
                          setCalculationTable(false);
                        }}
                      >
                        All
                      </p>
                      {uniqueClients.map((clientName, idx) => (
                        <p
                          key={idx}
                          className="p-2 hover:bg-gray-200"
                          onClick={() => {
                            handleClientChange(clientName);
                            setShowAllLeadTable(true);
                            setCalculationTable(false);
                          }}
                        >
                          {clientName}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex gap-3 p-1">
                <div
                  className="relative flex gap-2 justify-center items-center"
                  ref={dropdownRefYear}
                >
                  <label className="block text-sm font-semibold text-gray-700">
                    YEAR
                  </label>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsYearOpen(!isYearOpen);
                    }}
                    className="w-24 relative outline-none date-picker-placeholder flex gap-1 justify-start border border-[#e0e7ff] rounded-md p-2 text-xs"
                  >
                    <span className="truncate min-w-0 flex-1 text-left">
                      {selectedYears.length === 0
                        ? "All"
                        : selectedYears.join(", ").length < 14 // Adjust length limit as needed
                          ? selectedYears.join(", ")
                          : "Multiple"}
                    </span>
                    <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                  </button>

                  {isYearOpen && (
                    <div className="absolute left-0 top-full w-56 text-xs border overflow-hidden border-gray-400 bg-white shadow-md rounded-md z-50 max-h-64 overflow-y-auto">
                      {yearData.map((item) => {
                        const isYearSelected = selectedYears.includes(
                          item.Year.toString()
                        );

                        return (
                          <div
                            key={item.Year}
                            className="border-b border-gray-200"
                          >
                            <div className="flex align-middle items-center px-2">
                              <input
                                type="checkbox"
                                checked={selectedYears.includes(item.Year) || isYearSelected}
                                onChange={(e) => {
                                  handleYearSelection(item.Year);
                                }}
                              />{" "}
                              <button
                                className={`w-full text-left px-3 py-2 font-medium cursor-pointer`}
                                onClick={() => {
                                  setExpandedYear(
                                    expandedYear === item.Year ? null : item.Year
                                  );
                                }}
                              >
                                {item.Year}
                              </button>
                            </div>

                            {expandedYear === item.Year && (
                              <div className="px-4 pb-3 text-gray-600">
                                <div className="text-[10px] font-semibold">
                                  Months:
                                </div>
                                <div className="flex flex-wrap gap-1 mt-1 text-[11px]">
                                  {item.months.map((month) => {
                                    const value = `${item.Year} ${month}`;
                                    const isSelected =
                                      selectedYears.includes(value);

                                    return (
                                      <span
                                        key={month}
                                        onClick={() => handleYearSelection(value)}
                                        className={`px-2 py-[2px] rounded cursor-pointer border text-[11px]
                            ${isSelected
                                            ? "bg-blue-600 text-white border-blue-600"
                                            : "bg-blue-50 text-blue-800 border-blue-100 hover:bg-blue-100"
                                          }`}
                                      >
                                        {month}
                                      </span>
                                    );
                                  })}
                                </div>

                                <div className="mt-2 text-[10px] font-semibold">
                                  Quarters:
                                </div>
                                <div className="flex flex-wrap gap-1 mt-1 text-[11px]">
                                  {item.quarter.map((qtr) => {
                                    const value = `${item.Year} ${qtr}`;
                                    const isSelected =
                                      selectedYears.includes(value);

                                    return (
                                      <span
                                        key={qtr}
                                        onClick={() => handleYearSelection(value)}
                                        className={`px-2 py-[2px] rounded cursor-pointer border text-[11px]
                            ${isSelected
                                            ? "bg-green-600 text-white border-green-600"
                                            : "bg-green-50 text-green-800 border-green-100 hover:bg-green-100"
                                          }`}
                                      >
                                        {qtr}
                                      </span>
                                    );
                                  })}

                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="flex gap-4 align-middle items-center pr-4">
              {/* {financeTab !== "graph" && ( */}
              <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                <MdSearch className="w-5 h-5 text-gray-500" />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  placeholder="Search"
                  className="bg-[#e0e7ff] outline-none w-[80%]"
                />
              </div>

            </div>
          </div>

          {/* {financeTab === "table" && showTable === "QuotedExpense" && (
            <>
              <div ref={QuotationRef}
                className="">
                {showAllLeadTable && (
                  <div>
                    <div className="w-full max-h-[80vh] overflow-auto">
                      <div className="w-full head sticky top-0 z-10 flex text-white bg-black">
                        <div className="flex-shrink-0 w-10 px-3 py-3 flex items-center justify-center text-center border text-xs font-medium  tracking-wider bg-black">
                          Sr. No
                        </div>
                        <div className="flex-shrink-0 w-40 px-3 py-3 flex gap-2  justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                          Project Name
                          <div className="flex flex-col gap-y-1">
                            <div
                              className="cursor-pointer"
                              onClick={() =>
                                sortAlphabetically("projectname", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("projectname", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex-shrink-0 w-40 px-3 py-3 gap-2 flex justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                          Quoted Value ($)
                          <div className="flex flex-col gap-y-1">
                            <div
                              className="cursor-pointer"
                              onClick={() => numericSort("za")}
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() => numericSort("az")}
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex-shrink-0 w-40 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                          {selectedServiceTypes === "ERP" ? "Actual Expenses ($)" : "Quoted Expenses ($)"}
                        </div>
                        <div className="flex-shrink-0 w-40 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                          Gross Profit ($)
                        </div>
                        <div className="flex-shrink-0 w-40 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                          G&A Expenses ($)
                        </div>

                        <div className="flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                          Tax ($)
                        </div>
                        <div className="flex-shrink-0 w-44 flex flex-col justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                          <div className="h-[50%] w-full flex justify-center align-middle items-center"> Net Revenue</div>
                          <div className="h-[50%] flex w-full">
                            <div className="w-[50%] border flex justify-center align-middle items-center">($)</div>
                            <div className="w-[50%] border flex justify-center align-middle items-center">(%)</div>
                          </div>
                        </div>
                        <div className="flex-shrink-0 w-28 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                          Notes
                        </div>
                        <div className="flex-shrink-0  w-24 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium  capitalize bg-black">
                          Attachment/
                          <br />
                          Quotation
                        </div>
                      </div>

                      <div className="w-full">
                        {currentItems.map((row, index) => (
                          <>
                            {selectedServiceTypes === "QuotedExpense" && (
                              <div key={index} className={`CRMandERPtableone w-full flex`}>
                                <div
                                  onClick={() => {
                                    if (showExpensesop(row.ProjectName, row.quotationId) !== "0") {
                                      setSelectedProjectName(row);
                                      setCalculationTable(true);
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                    }
                                    handleTabClick("AllServiceTable")
                                  }} className={`flex-shrink-0 w-10 ${showExpensesop(row.ProjectName, row.quotationId) !== "0" ? "cursor-pointer" : ""} px-3 py-3 flex items-center justify-center text-center border-b text-xs font-medium  tracking-wider `}>
                                  {startIdx + index + 1}
                                </div>
                                <div
                                  onClick={() => {
                                    if (showExpensesop(row.ProjectName, row.quotationId) !== "0") {
                                      setSelectedProjectName(row);
                                      setCalculationTable(true);
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                    }
                                    handleTabClick("AllServiceTable")
                                  }}
                                  className={`flex-shrink-0 w-40 ${showExpensesop(row.ProjectName, row.quotationId) !== "0" ? "cursor-pointer" : ""} px-3 py-3 flex gap-2  justify-center align-middle items-center text-center border-b text-xs font-medium  tracking-wider capitalize `}
                                >
                                  {row.ProjectName}

                                </div>
                                <div onClick={() => {
                                  if (showExpensesop(row.ProjectName, row.quotationId) !== "0") {
                                    setSelectedProjectName(row);
                                    setCalculationTable(true);
                                    setOpenDropdownIndex(
                                      openDropdownIndex === null
                                    );
                                  }
                                  handleTabClick("AllServiceTable")
                                }}
                                  className={`flex-shrink-0 ${showExpensesop(row.ProjectName, row.quotationId) !== "0" ? "cursor-pointer" : ""} w-40 p-2 gap-2 flex justify-center align-middle items-center text-center border-b text-xs font-medium  tracking-wider capitalize`}>
                                  {USAComma(row.QuotedValue)}
                                </div>

                                <div
                                  onClick={() => {
                                    if (showExpensesop(row.ProjectName, row.quotationId) !== "0") {
                                      setSelectedProjectName(row);
                                      setCalculationTable(true);
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                    }
                                    handleTabClick("AllServiceTable")
                                  }}
                                  className={`quotedExpense ${showExpensesop(row.ProjectName, row.quotationId) !== "0" ? "cursor-pointer" : ""} relative group flex-shrink-0 w-40 px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs font-medium tracking-wider capitalize`}>

                                  {showExpensesop(row.ProjectName, row.quotationId)}

                                </div>
                                <div
                                  onClick={() => {
                                    if (showExpensesop(row.ProjectName, row.quotationId) !== "0") {
                                      setSelectedProjectName(row);
                                      setCalculationTable(true);
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                    }
                                    handleTabClick("AllServiceTable")
                                  }} className={`GrossProfit flex-shrink-0 w-40 ${showExpensesop(row.ProjectName, row.quotationId) !== "0" ? "cursor-pointer" : ""} px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs font-medium tracking-wider capitalize text-wrap break-all 
    ${calculateGrossProfit(row.ProjectName) < 0 ? "text-red-500" : "text-black"}`}
                                >
                                  {USAComma(calculateGrossProfit(row.ProjectName))}
                                </div>
                                <div
                                  onClick={() => {
                                    if (showExpensesop(row.ProjectName, row.quotationId) !== "0") {
                                      setSelectedProjectName(row);
                                      setCalculationTable(true);
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                    }
                                    handleTabClick("AllServiceTable")
                                  }} className={`G&AExpenses flex-shrink-0 w-40 ${showExpensesop(row.ProjectName, row.quotationId) !== "0" ? "cursor-pointer" : ""} px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs font-medium tracking-wider capitalize text-wrap break-all 
    ${calculateGrossProfit(row.ProjectName) * (GandATax / 100) < 0 ? "text-red-500" : "text-black"}`}
                                >
                                  {USAComma(calculateGrossProfit(row.ProjectName) * (GandATax / 100))}
                                </div>
                                <div
                                  onClick={() => {
                                    if (showExpensesop(row.ProjectName, row.quotationId) !== "0") {
                                      setSelectedProjectName(row);
                                      setCalculationTable(true);
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                    }
                                    handleTabClick("AllServiceTable")
                                  }}
                                  className={`Tax flex-shrink-0 w-24 ${showExpensesop(row.ProjectName, row.quotationId) !== "0" ? "cursor-pointer" : ""} px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs font-medium tracking-wider capitalize text-wrap break-all
    
    ${calculateGrossProfit(row.ProjectName) * (taxValue / 100) < 0 ? "text-red-500" : "text-black"}`}
                                >
                                  {USAComma(calculateGrossProfit(row.ProjectName) * (taxValue / 100))}
                                </div>

                                <div
                                  onClick={() => {
                                    if (showExpensesop(row.ProjectName, row.quotationId) !== "0") {
                                      setSelectedProjectName(row);
                                      setCalculationTable(true);
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                    }
                                    handleTabClick("AllServiceTable")
                                  }} className={`flex-shrink-0 w-44 flex ${showExpensesop(row.ProjectName, row.quotationId) !== "0" ? "cursor-pointer" : ""} justify-center align-middle items-center text-center border-b text-xs font-medium  tracking-wider capitalize text-wrap break-all`}>
                                  <div
                                    className={`NetRevenue w-[50%]  flex justify-center align-middle items-center text-wrap break-all
    ${(
                                        (calculateGrossProfit(row.ProjectName) - (calculateGrossProfit(row.ProjectName) * (GandATax / 100))) -
                                        (calculateGrossProfit(row.ProjectName) * (taxValue / 100))
                                      ) < 0 ? "text-red-500" : "text-black"}`}
                                  >
                                    {USAComma(
                                      (calculateGrossProfit(row.ProjectName) -
                                        calculateGrossProfit(row.ProjectName) * (GandATax / 100)) -
                                      calculateGrossProfit(row.ProjectName) * (taxValue / 100)
                                    )}
                                  </div>

                                  <div
                                    className={`NetRevenuePercentage w-[50%] flex justify-center align-middle items-center text-wrap break-all
    ${(
                                        (
                                          (
                                            (calculateGrossProfit(row.ProjectName) -
                                              calculateGrossProfit(row.ProjectName) * (GandATax / 100)) -
                                            calculateGrossProfit(row.ProjectName) * (taxValue / 100)
                                          ) /
                                          quotedValues[row.ProjectName]
                                        ) * 100
                                      ) < 0 ? "text-red-500" :
                                        (
                                          (
                                            (
                                              (calculateGrossProfit(row.ProjectName) -
                                                calculateGrossProfit(row.ProjectName) * (GandATax / 100)) -
                                              calculateGrossProfit(row.ProjectName) * (taxValue / 100)
                                            ) /
                                            quotedValues[row.ProjectName]
                                          ) * 100
                                        ) < 10 ? "text-orange-600" :
                                          "text-black"}`}
                                  >
                                    {(
                                      (
                                        (
                                          (calculateGrossProfit(row.ProjectName) -
                                            calculateGrossProfit(row.ProjectName) * (GandATax / 100)) -
                                          calculateGrossProfit(row.ProjectName) * (taxValue / 100)
                                        ) /
                                        quotedValues[row.ProjectName]
                                      ) * 100
                                    ).toFixed(2)}
                                  </div>

                                </div>
                                <div
                                  className={`flex-shrink-0 w-28 break-words text-wrap flex justify-center items-center text-center border-b text-xs font-medium tracking-wider capitalize`}
                                >
                                  <textarea
                                    className="leadComments w-28 h-full outline-none text-center break-words whitespace-normal resize-none overflow-x-hidden"
                                    value={comments[row.ProjectName] || ""}
                                    onChange={(e) => handleCommentsChange(row, e.target.value)}
                                    placeholder="Enter Notes"
                                  />

                                </div>

                                <div
                                  className={`flex-shrink-0 cursor-pointer w-24 px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs font-medium  tracking-wider capitalize`}>
                                  <FinanceFileUpload row={row} setOpenDropdownIndex={
                                    setOpenDropdownIndex
                                  }
                                    openDropdownIndex={openDropdownIndex} />
                                </div>
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                <div className="pagination border flex justify-between items-center bg-white pt-2 pb-2 p-1 rounded-b-md">
                  <div>
                    {totalItems > 0 ? (
                      <>
                        Showing {startIdx + 1} to {Math.min(endIdx, totalItems)}{" "}
                        of {totalItems} Entries
                      </>
                    ) : (
                      <>Showing 0 Entries</>
                    )}
                  </div>
                  {totalPages > 1 && (
                    <div>
                      <button
                        onClick={() => setCurrentPage(1)}
                        className="px-2 py-2 mx-1 border rounded"
                        disabled={currentPage === 1}
                        title="First Page"
                      >
                        <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                      </button>
                      <button
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        className="px-2 py-2 mx-2 border rounded"
                        disabled={currentPage === 1}
                      >
                        <ChevronRightIcon className="w-5 h-5 rotate-180" />

                      </button>

                      {Array.from({ length: 3 }, (_, index) => {
                        const pageNumber = currentPage - 1 + index;

                        if (pageNumber >= 1 && pageNumber <= totalPages) {
                          return (
                            <button
                              key={pageNumber}
                              onClick={() => setCurrentPage(pageNumber)}
                              className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber ? "bg-gray-300" : ""
                                }`}
                            >
                              {pageNumber}
                            </button>
                          );
                        }

                        return null;
                      })}

                      <button
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        className="px-2 py-2 mx-2 border rounded"
                        disabled={currentPage === totalPages}
                      >
                        <ChevronRightIcon className="w-5 h-5" />

                      </button>

                      <button
                        onClick={() => setCurrentPage(totalPages)}
                        className="px-2 py-2 mx-1 border rounded"
                        disabled={currentPage === totalPages}
                        title="Last Page"
                      >
                        <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                      </button>
                    </div>
                  )}
                </div>
                {calculationTable && (
                  selectedTab === "AllServiceTable" && (
                    <>
                      <div ref={AllServiceTableRef}>

                        <FinanceData
                          filteredQuotation={filteredQuotation}
                          selectedProject={selectedProjectName}
                          projects={projects}
                          calculatedProjects={calculatedProjects}
                          tasks={tasks}
                          items={items} />
                      </div>
                    </>
                  )
                )}



              </div>
            </>
          )} */}

          {/* <div className="pt-5">
                  <SearchSalesGrossProfit financeDataProject={financeDataProject} calculatedProjects={calculatedProjects} packages={profiles[0]?.subscriptionpackage} showTable={showTable} searchedLeadReports={searchedLeadReports} searchedLeadReportswithoutyears={searchedLeadReportswithoutyears} />
                  <SearchedSalesNetMargin financeDataProject={financeDataProject} calculatedProjects={calculatedProjects} packages={profiles[0]?.subscriptionpackage} showTable={showTable} searchedLeadReports={searchedLeadReports} searchedLeadReportswithoutyears={searchedLeadReportswithoutyears} />
                </div> */}

          {/* When package is CRM, P&L Quoted Expenses (₹) and Gross Profit use leads.quotedExpense; see ActualFinanceView. */}
          {(financeTab === "table" && showTable === "Actual") && (
            <div ref={ActualRef}>
              <ActualFinanceView 
                searchedLeadReportswithoutyears={searchedLeadReportswithoutyears} 
                showTable={showTable} 
                searchedLeadReports={searchedLeadReports}
                selectedYears={selectedYears}
              />
            </div>
          )}


        </div>


        {/* for manager */}
        {/* <ManagerTable /> */}
      </div >
      )}
    </>
  );
};

export default FinanceOverview;
